// https://csv.js.org/parse/api/
import csvParse from "csv-parse";

export default async function (csv: Buffer | string, options: csvParse.Options) {
    return new Promise((resolve, reject) => {
        csvParse(csv, options, (error: Error | undefined, records: any | undefined) => {
            if (error) {
                reject(error);
                return;
            }

            resolve(records);
        });
    });
}
